export default (id) => ({
  slideDirection: null,
  index: 0,
  oldIndex: null,
  count: null,

  select(newIndex) {
    this.oldIndex = this.index;
    this.index = newIndex;
    this.slideDirection = this.oldIndex < this.index ? 'left' : 'right';
  },

  itemClass(itemIndex) {
    if (itemIndex === this.oldIndex) {
      return `carousel__content__item--hide-${this.slideDirection}`
    }
    if (itemIndex === this.index) {
      if (this.slideDirection) {
        return `carousel__content__item--show-${this.slideDirection}`
      }
      else {
        return 'carousel__content__item--active'
      }
    }
  },

  next() {
    this.slideDirection = 'left';
    this.oldIndex = this.index;
    this.index = (this.index + 1) % this.count;
  },

  prev(e) {
    this.slideDirection = 'right';
    this.oldIndex = this.index;
    this.index = (this.index - 1 + this.count) % this.count;
  },

  init() {
    this.count = document.getElementById(id).querySelector('.carousel__content').childElementCount
  },
});
